// (function ($) {
//   Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
//     get: function () {
//       return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
//     }
//   });
//
//   $('body').on('click touchstart','.fullscreen-video__wrapper', function (e) {
//     if ($(this).find('video').playing) {
//
//     } else {
//       $(this).find('video').get(0).play();
//       $(this).removeClass('show-button');
//     }
//   });
//
//   $('body').on('click touchstart','.hero-banner__wrapper', function (e) {
//     $.each($(this).find('.fullscreen-video__wrapper'),function (index,item) {
//       if($(item).css('display') != 'none') {
//         if ($(item).find('video').playing) {
//
//         } else {
//           $(item).find('video').get(0).play();
//           $(item).removeClass('show-button');
//         }
//       }
//     })
//   });
//
//   $(document).ready(function () {
//     $.each($('.fullscreen-video__wrapper video'),function (index,item) {
//       $(item).on('suspend', () => {
//         $(item).parent().addClass('show-button')
//         console.log('suspended')
//       })
//       $(item).on('play', () => {
//         $(item).parent().removeClass('show-button')
//         console.log('played')
//       });
//     })
//     $.each($('video'),function (index,item) {
//       if ($(item).playing) {
//         $(item).parent().removeClass('show-button');
//       }
//     })
//   });
//
// }(jQuery));